export default "__VITE_ASSET__hntPnld___"